import React from 'react';
import { Badge } from '../../components/ui/badge';
import { User, Bot, Sparkles, AlertTriangle, CheckCircle } from 'lucide-react';

const renderFeedback = (fb) => {
  if (!fb) return null;
  if (typeof fb === 'string') return <p className="text-sm text-gray-700">{fb}</p>;
  const items = [];
  if (fb.score !== undefined && fb.score !== null) items.push(<Badge key="s" className="bg-emerald-100 text-emerald-800">Answer score {fb.score}/10</Badge>);
  const text = fb.comment || fb.feedback || fb.summary || fb.message;
  if (text) items.push(<p key="t" className="text-sm text-gray-700">{text}</p>);
  const strengths = fb.strengths || [];
  const flags = fb.red_flags || fb.improvements || fb.areas_for_improvement || [];
  strengths.forEach((s, i) => items.push(<p key={`st${i}`} className="text-xs text-emerald-700 flex gap-1"><CheckCircle className="h-3 w-3 mt-0.5 flex-shrink-0" />{s}</p>));
  flags.forEach((f, i) => items.push(<p key={`fl${i}`} className="text-xs text-amber-700 flex gap-1"><AlertTriangle className="h-3 w-3 mt-0.5 flex-shrink-0" />{f}</p>));
  if (items.length === 0) {
    Object.entries(fb).forEach(([k, v]) => {
      if (typeof v === 'string' || typeof v === 'number') items.push(<p key={k} className="text-xs text-gray-600"><span className="font-medium capitalize">{k.replace(/_/g, ' ')}:</span> {v}</p>);
    });
  }
  return items.length ? <div className="space-y-1">{items}</div> : null;
};

export const ReplayTurn = ({ turn, index }) => {
  const isAI = turn.role === 'ai';
  const feedback = renderFeedback(turn.feedback);
  return (
    <div className={`flex gap-3 ${isAI ? '' : 'flex-row-reverse'} animate-in fade-in slide-in-from-bottom-2 duration-300`} data-testid={`replay-turn-${index}`}>
      <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${isAI ? 'bg-emerald-500' : 'bg-slate-700'}`}>
        {isAI ? <Bot className="h-4 w-4 text-white" /> : <User className="h-4 w-4 text-white" />}
      </div>
      <div className={`max-w-[80%] space-y-2 ${isAI ? '' : 'items-end'}`}>
        <div className={`rounded-2xl px-4 py-3 shadow-sm ${isAI ? 'bg-white border border-emerald-100 rounded-tl-sm' : 'bg-slate-800 text-white rounded-tr-sm'}`}>
          {turn.phase && <span className={`text-[10px] uppercase tracking-wide ${isAI ? 'text-emerald-600' : 'text-slate-300'}`}>Phase {turn.phase}</span>}
          <p className="text-sm whitespace-pre-wrap">{turn.message}</p>
          {turn.response_time_seconds !== undefined && turn.response_time_seconds !== null && (
            <p className="text-[10px] text-slate-300 mt-1">Answered in {Math.round(turn.response_time_seconds)}s</p>
          )}
        </div>
        {feedback && (
          <div className="rounded-xl bg-amber-50 border border-amber-200 px-3 py-2" data-testid={`replay-feedback-${index}`}>
            <p className="text-[10px] uppercase tracking-wide text-amber-700 flex items-center gap-1 mb-1"><Sparkles className="h-3 w-3" />Coach feedback</p>
            {feedback}
          </div>
        )}
      </div>
    </div>
  );
};
